export default __webpack_public_path__ + "static/heroSectionBgMob-c672cfc0509be43b9c7b1a5be1a1c18f.png";